import ListSelector from '../util/ListSelector';
import InlineTextEdit from '../util/InlineTextEdit';

const ACTION_TYPES = ['email'];

/* eslint-disable jsx-a11y/label-has-associated-control */

const TypeSelector = ({ selected, onChange }) => (
  <label>
    <span className="alert-label">Action type:</span>
    <ListSelector values={ACTION_TYPES} selected={selected} onChange={onChange} />
  </label>
);

const getParamsSection = (type, params, setParams) => {
  if (type === 'email') {
    return (
      <InlineTextEdit
        label="Status email recipient"
        value={params?.email ?? ''}
        onValueChange={(v) => setParams({ email: v })}
      />
    );
  }
  return null;
};

export { TypeSelector, getParamsSection };
